import api from 'utils/rw-subordinates/resources/subordinate-list.api';
import template from './rw-multistore-selector.html';

const mapStateToThis = ({ config, session }) => {
  const { retailer } = session;
  const { sortColumnKey, directionKey, defaultPageNo, defaultPageSizes } = config;

  return {
    retailer,
    sortColumnKey,
    directionKey,
    defaultPageNo,
    defaultPageSizes,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'Notifications')
class RwMultistoreSelectorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  async $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    // eslint-disable-next-line prefer-destructuring
    this.threshold = this.defaultPageSizes[1];
    await this.loadData();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async loadData() {
    const requestParams = {
      [this.sortColumnKey]: 'retailerType',
      [this.directionKey]: 'asc',
      pageNumber: this.defaultPageNo,
      pageSize: this.threshold,
      retailerId: this.retailerId,
    };
    const { content } = await api.fetchSubordinateList(requestParams);
    this.locations = content;
  }

  shouldShowDropdown() {
    return this.locations && this.locations.length < this.threshold;
  }

  onOpenDialog() {
    this.Notifications.showComplexDialog({
      component: 'rwMultistoreSelectorDialog',
    });
  }
}

export default class RwMultistoreSelectorComponent {
  constructor() {
    this.template = template;
    this.controller = RwMultistoreSelectorController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-multistore-selector/rw-multistore-selector-component.js